import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { avantorAnimations } from '@core/animations/animations';
import { MessageService } from '@core/services/message/message-api';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-messages-panel',
  templateUrl: './messages-panel.html',
  styleUrls: ['./messages-panel.scss'],
  animations: [avantorAnimations],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class MessagesPanelComponent implements OnInit {

  constructor(
    private messageService: MessageService
  ) { }

  ngOnInit(): void {

  }

  /**---------------------------------------------
  * @CLOSE_PANEL
  * Close panel event
  */
  @Input() openPanel: boolean = false;
  @Output() closePanel = new EventEmitter<void>();

  close() {
    this.closePanel.emit();
  }


}
